import createAxiosInstance from "../LambdaApiFrecuencias";

export async function PutFetchCatalogoRecolecion(body) {
  const axiosInstance = await createAxiosInstance();
  const requestConfig = {
    method: "PUT", // Cambia el método si es necesario
    url: `/frecuencias`,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  };
  return axiosInstance(requestConfig);
}
